interface CheckIconProps {
  color?: string;
}

export const CheckIcon = ({color}: CheckIconProps) => (
  <svg width="18" height="13" viewBox="0 0 18 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M17.4375 0.523438C17.8281 0.914062 17.8281 1.5 17.4375 1.85156L7.125 12.1641C6.77344 12.5547 6.1875 12.5547 5.83594 12.1641L0.523438 6.85156C0.132812 6.5 0.132812 5.91406 0.523438 5.52344C0.875 5.17188 1.46094 5.17188 1.8125 5.52344L6.5 10.2109L16.1484 0.523438C16.5 0.171875 17.0859 0.171875 17.4375 0.523438Z" fill={color ?? "#009444"} />
  </svg>
)